import React, { FC, Key, ReactElement, useState } from 'react'
import ProTable, { ProColumns } from "@ant-design/pro-table";
import { Button } from 'antd';
import { ModalForm } from "@ant-design/pro-form";
import { PlusOutlined } from "@ant-design/icons";
import { fetchCustomerList } from './customer.reducer';
import { Customer } from 'model/customerCore/customer.model';

export const columns: ProColumns<Customer>[] = [{
  title: '头像',
  dataIndex: 'avatar',
  valueType: 'avatar',
  width: 60,
  hideInSearch: true,
}, {
  title: '客户名称',
  dataIndex: 'name',
  valueType: 'text',
  width: 100,
  hideInSearch: true,
  render: (text, record: Customer) => record.name && record.name !== '' ? record.name : '匿名用户',
}, {
  title: 'code',
  dataIndex: ['code'],
  valueType: 'text',
  hideInDescriptions: true,
  hideInSearch: true,
}, {
  title: '用户ID',
  dataIndex: 'userId',
  valueType: 'text',
  hideInSearch: true,
}, {
  title: '用户昵称',
  dataIndex: 'name.contains',
  hideInTable: true,
}, {
  title: '用户userId',
  dataIndex: 'userId.equals',
  hideInTable: true,
}, {
  title: '用户code',
  dataIndex: 'code.equals',
  hideInTable: true,
}];

export interface ProductSelectionFormProps {
  trigger?: string;
  triggerRender?: ReactElement;
  name?: string;
  multiple?: boolean;
  productIds?: string[];
  requestParams?: any;
  onFinish: (productIds: string[], products: Customer[]) => void;
}

const CustomerSelectionForm: FC<ProductSelectionFormProps> = (props) => {
  const {
    // getEntities,
    trigger,
    onFinish,
    triggerRender,
    multiple = true,
    requestParams = {},
  } = props;

  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<Customer[]>([]);

  return (
    <ModalForm<Customer[]>
      title="选择客户"
      width={1000}
      trigger={triggerRender ||
        <Button type="primary">
          <PlusOutlined />
          {trigger}
        </Button>
      }
      onFinish={async () => {
        onFinish((selectedRowKeys?.map(item => item.toString())) || [], selectedRows);
        return true;
      }}
    >
      <ProTable<Customer, Record<string, any>>
        rowKey="id"
        search={{
          filterType: 'light',
        }}
        dateFormatter="string"
        columns={columns}
        rowSelection={{
          type: multiple ? 'checkbox' : 'radio',
          onChange: (selectedRowKeys: Key[], selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
            setSelectedRows(selectedRows);
          }
        }}
        pagination={{
          showQuickJumper: true,
        }}
        request={async (params) => {
          const result = await fetchCustomerList({
            page: (params?.current && params?.current - 1) || 0,
            size: params?.pageSize || 20,
            sort: 'id',
            ...requestParams,
            ...params
          });
          return {
            success: true,
            total: result.headers?.['x-total-count'],
            data: result.data,
          };
        }}
      />
    </ModalForm>
  );
};

export default CustomerSelectionForm;